import { mapGetters } from 'vuex'

export const isFactoringEnabled = {
  computed: {
    ...mapGetters('settings', ['isFactoringEnabled'])
  }
}
